import React from 'react';
import { useStudioTypeSize } from '../../StudioTypeScale';
import EditorialFrame, { type EditorialInjectedProps, type EditorialLayoutProps } from './EditorialFrame';

const EditorialTitleBulletsContent: React.FC<EditorialInjectedProps & { content: any }> = ({
  content,
  tokens,
  isStory
}) => {
  const t = tokens!;
  const typeSize = useStudioTypeSize();
  const bullets = Array.isArray(content.bullets) ? content.bullets : [];

  return (
    <div>
      <h2
        style={{
          maxWidth: 285,
          margin: 0,
          color: t.ink,
          fontFamily: t.serif,
          fontSize: typeSize(isStory ? 35 : 28),
          fontWeight: 700,
          letterSpacing: '-1px',
          lineHeight: 1.12
        }}
      >
        {content.title}
      </h2>
      {content.subtitle ? (
        <p
          style={{
            maxWidth: 278,
            margin: isStory ? '13px 0 0' : '10px 0 0',
            color: t.muted,
            fontFamily: t.serif,
            fontSize: typeSize(isStory ? 14 : 12),
            fontStyle: 'italic',
            lineHeight: 1.5
          }}
        >
          {content.subtitle}
        </p>
      ) : null}

      <div
        style={{
          marginTop: isStory ? 25 : 18,
          borderTop: `2px solid ${t.ink}`
        }}
      >
        {bullets.map((bullet: string, index: number) => (
          <div
            key={`${index}-${bullet}`}
            style={{
              display: 'grid',
              gridTemplateColumns: isStory ? '38px 1fr' : '32px 1fr',
              gap: isStory ? 13 : 10,
              alignItems: 'start',
              padding: isStory ? '14px 0' : '10px 0',
              borderBottom: `1px solid ${t.line}`
            }}
          >
            <span
              style={{
                color: t.accent,
                fontFamily: t.serif,
                fontSize: typeSize(isStory ? 22 : 18),
                fontStyle: 'italic',
                fontWeight: 700,
                lineHeight: 1
              }}
            >
              {String(index + 1).padStart(2, '0')}
            </span>
            <span
              style={{
                color: t.ink,
                fontSize: typeSize(isStory ? 14.5 : 12.5),
                fontWeight: 650,
                lineHeight: 1.45
              }}
            >
              {bullet}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

const EditorialTitleBulletsLayout: React.FC<EditorialLayoutProps> = props => (
  <EditorialFrame {...props}>
    <EditorialTitleBulletsContent content={props.content || {}} />
  </EditorialFrame>
);

export default EditorialTitleBulletsLayout;
